<template>
  <div class="pagemain">

    <div class="form-group">
      <div class="form-group-content">
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="貨幣">
              <div style="display: flex;">
                <div style="margin-right: 10px;"><img class="currencyimg" src="~@/assets/1.png"></div>
                <div>CNY 人民幣</div>
              </div>
            </el-form-item>

          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="賬戶號碼" prop="account_num">
              <el-input  v-model="form.account_num_format" @input="cardformat()" @change="cardformat" ref="cardInput" clearable></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="賬戶戶名" prop="account_name">
              <el-input v-model="form.account_name">
                <el-button slot="append" @click="form.account_name=sify(form.account_name)">繁轉簡</el-button>
              </el-input>
            </el-form-item>

          </div>
          <div class="mm-col ml-20">
            <el-button @click="openchooseholder">使用戶主名稱</el-button>
            <el-dialog @closed="closechooseholder" title="導入戶主名稱" :visible.sync="chooseholder" width="95%"  :append-to-body="true">
              <component @closeholder="closeholder" :is="chooseholder_component"></component>
            </el-dialog>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="銀行名稱" prop="bankname">
              <cnbankselect :key="form.account_num" :form="form"></cnbankselect>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="銀行代碼" prop="bankcode">
              <el-input v-model="form.bankcode"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="備註信息" prop="mark">
              <el-input v-model="form.mark"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <el-form-item label="使用狀態">
            <el-switch v-model="form.status" active-text="啟用" inactive-text="禁用">
            </el-switch>
          </el-form-item>

        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="餘額" prop="balance">
              <el-input v-model="form.balance" disabled=""></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="單日限額" prop="day_limit">
              <el-input v-model="form.day_limit"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="單月限額" prop="day_limit">
              <el-input v-model="form.month_limit"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="30日限額" prop="day_limit">
              <el-input v-model="form.limit_30"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="創建日期" prop="addtime">
              <el-date-picker v-model="form.addtime" type="date" placeholder="選擇日期" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import cnbankselect from '@/components/CNBankSelect.vue';
import chooseholder from './ChooseHolder.vue';
import BankCardInfo from 'bankcardinfo';
export default {
  components: {
    cnbankselect,
    chooseholder
  },
  props: ['form'],
  data () {
    return {
      bankListBF: [],
      loading: false,
      chooseholder: false,
      chooseholder_component: '',
    };
  },
  methods: {
    cardformat () {
      let val = this.form.account_num_format;
      this.formatCardNumber(this.form, val);
    },
    getbankinfo () {
      let val = this.form.account_num;
      if (val.length >= 13) {
        var _this = this;
        BankCardInfo.getBankBin(val)
          .then(function (data) {
            if (data.bankName) {
              _this.post('/api/bank/getbank_by_bankcode', data).then(response => {
                _this.form.bankname = response.name;
                _this.form.cnbank_id = response.id;
              }).catch(error => {
                _this.form.bankname = '';
                _this.form.cnbank_id = 0;
              });
            }
          })
          .catch(function (err) {
            _this.form.bankname = '';
            _this.form.cnbank_id = 0;
          })
      } else {
        this.form.bankname = '';
        this.form.cnbank_id = 0;
      }
    },
    pageback () {
      this.$router.go(-1);
    },
    closeholder (holder) {

      this.chooseholder = false;
      this.chooseholder_component = '';
      this.form.account_name = holder.name;

    },
    closechooseholder () {
      this.chooseholder = false;
      this.chooseholder_component = '';
    },
    openchooseholder () {
      this.chooseholder = true;
      this.chooseholder_component = chooseholder;
    },
    // 獲取銀行列表
    getBanksList () {
      this.post('/api/bank/banks', { page: 1, size: 1000, condition: '' })
        .then(response => {
          // console.log(response);
          this.bankListBF = response;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  created () {
    this.getBanksList();
    // console.log(this.form);
    this.form.currency_id = 1;
  },
  watch: {
    'form.account_num_format' (val) {
      if (val) {
        this.form.account_num = this.mytrim(val);
      } else {
        this.form.account_num = '';
      }
    },
    'form.account_num' (val) {
      if (val.length >= 13) {
        var _this = this;
        BankCardInfo.getBankBin(val)
          .then(function (data) {
            if (data.bankName) {
              if (data.bankName == '深发/平安银行') {
                data.bankName = '平安银行';
              }
              _this.bankListBF.some(item => {
                if (item.name == data.bankName) {
                  _this.form.cnbank_id = item.id + '';
                }
              })
              _this.form.bankinfo = _this.form.bankname = data.bankName;
            }
          })
          .catch(function (err) {
            console.log(err);
            _this.form.bankinfo = _this.form.bankname = '';
          })
      }
    },
    'form.cnbank_id' (val) {
      this.bankListBF.some(item => {
        if (val == item.id) {
          this.form.bankinfo = this.form.bankname = item.name;
        }
      })
    },
    'form.bankinfo' (val) {
      this.form.bankname = this.form.bankinfo;
    },
  }
};
</script>


<style scoped>
.mm-row {
}

.currencyimg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: block;
}
.ml-20{ margin-left: 20px;}
@media screen and (max-width: 1024px) {
		 .mm-row {
		 	width: 100%;
			display: block;
		 }
		 .ml-20{ margin: 0;}
		}
</style>
